import { useLocation } from "react-router-dom";
import { getUserBasicInfo } from "@/services/users/getUserBasicInfo";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getGuidePlatformCloseManually,
  setCurrentForm,
  setIsLoggedIn,
  setModalOpen,
  setToken,
  setUserInfo,
} from "@/reducers/commonSlice";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isGuidePlatformCloseManually = useSelector(getGuidePlatformCloseManually);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (localStorage.getItem("token")) {
    getUserBasicInfo()
      .then((response) => {
        if (response.roles.length === 0) {
          dispatch(setCurrentForm("registrationCategories"));
          dispatch(setModalOpen(true));
          return;
        } else if (!response.stage) {
          if (response.roles[0].name === "Guide") {
            if (!isGuidePlatformCloseManually) {
              dispatch(setCurrentForm("guidePlatform"));
              dispatch(setModalOpen(true));
            }
          } else {
            dispatch(setCurrentForm("journeySelection"));
            dispatch(setModalOpen(true));
            return;
          }
        }
        dispatch(setUserInfo(response));
        dispatch(setIsLoggedIn(true));
        dispatch(setToken(localStorage.getItem("token")));
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("token");
      });
  }
  return null;
};

export default ScrollToTop;
